<template>
  <div></div>
</template>

<script>
export default {
    name:'AfterPage',
    created(){
        window.location.href = 'https://mancenter.renhegroup.net/After'
    }
}
</script>

<style>

</style>